import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=2c98237b&scoped=true&"
import script from "./Scale.vue?vue&type=script&lang=js&"
export * from "./Scale.vue?vue&type=script&lang=js&"
import style0 from "./Scale.vue?vue&type=style&index=0&id=2c98237b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c98237b",
  null
  
)

export default component.exports